import _ from 'underscore';
import jQuery from 'jquery';
import angular from 'angular';

function SettingsVenueFloorplansCtrl($scope, $q, $stateParams, layoutService, layoutTableService, layoutSectionService, sdkUtils, alertService, $state, ERROR_MESSAGES, modalService, $timeout, sdkVenueService) { //eslint-disable-line
  $scope.venuePromise = sdkVenueService.readById($stateParams.venueId);

  _initScope();

  $q.all([
      $scope.venuePromise,
      _getVenueLayouts(),
      _getVenueLayoutTables(),
      _getVenueLayoutSections()
    ])
    .then(results => {
      $scope.venue = results[0];
      $scope.layouts = _.sortBy(results[1], 'order');
      $scope.currentLayout = $scope.layouts && $scope.layouts.length ? $scope.layouts[0] : null;
      $scope.layoutTables = results[2];
      $scope.layoutSections = results[3];

      _mapLayoutTables();
    })
    .finally(() => {
      $scope.currentSections = _currentSections;
      $scope.loading = false;
    });

  function _initScope() {
    $scope.loading = true;

    $scope.layoutSectionForm = {};
    $scope.addLayoutTable = _addLayoutTable;
    $scope.deleteLayoutTable = _deleteLayoutTable;
    $scope.saveLayoutTable = _saveLayoutTable;
    $scope.editLayoutTable = _editLayoutTable;

    $scope.addLayoutSection = _addLayoutSection;
    $scope.cancelAddLayoutSection = _cancelAddLayoutSection;
    $scope.createLayoutSection = _createLayoutSection;
    $scope.saveLayoutSection = _saveLayoutSection;
    $scope.deleteLayoutSection = _deleteLayoutSection;
    $scope.editLayoutSection = _editLayoutSection;
    $scope.sectionSelected = _sectionSelected;
    $scope.sectionDeselected = _sectionDeselected;
    $scope.layoutTableForm = {};
    $scope.changeLayout = _changeLayout;
    $scope.addFloorplan = _addFloorplan;
    $scope.deleteFloorplan = _deleteFloorplan;
    $scope.layoutTableDraggableOptions = {
      appendTo: 'body',
      cursor: 'pointer',
      cursorAt: {
        top: 24,
        left: 30
      },
      stop: _handleTableMoved
    };

    if ($stateParams.addNew) {
      $scope.addFloorplan();
    }
  }

  function _changeLayout(layout, $event) {
    if ($event) $event.preventDefault();

    $scope.currentLayout = layout;
  }

  function _getVenueLayouts() {
    $scope.loading = true;

    return layoutService.listByVenueId($stateParams.venueId)
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _getVenueLayoutTables() {
    $scope.loading = true;

    return layoutTableService.listByVenueId($stateParams.venueId, {
        limit: 1000
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _getVenueLayoutSections() {
    $scope.loading = true;

    return layoutSectionService.listByVenueId($stateParams.venueId)
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _deleteLayoutTable(layoutTable, $event) {
    if (!layoutTable) return;
    if ($event) $event.preventDefault();

    modalService.confirmation({
        modalHeader: 'Delete Table',
        modalMessage: `Are you sure you want to table ${layoutTable.name}`,
        confirmBtnTxt: 'Delete Table',
        confirmingBtnTxt: 'Deleting...'
      })
      .then(result => {
        if (result && result.confirm) {
          layoutTableService.deleteById(layoutTable.id)
            .then(() => {
              const index = $scope.layoutTables.indexOf(layoutTable);

              if (index >= 0) $scope.layoutTables.splice(index, 1);

              result.modalInstance.close();
            })
            .catch(error => {
              alertService.error(sdkUtils.getErrorFromResponse(error));
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function _addLayoutSection($event) {
    if ($event) $event.preventDefault();
    $scope.addingSection = true;
  }

  function _cancelAddLayoutSection($event) {
    if ($event) $event.preventDefault();
    $scope.addingSection = false;
  }

  function _createLayoutSection($event) {
    if ($event) $event.preventDefault();

    const form = $scope.layoutSectionForm || {};
    form.venueLayoutId = $scope.currentLayout.id;
    form.venueId = $stateParams.venueId;

    layoutSectionService.create(form)
      .then(result => $scope.layoutSections.push(result))
      .then(() => {
        $scope.addingSection = false;

        $scope.layoutSectionForm.name = null;
      })
      .then(() => {
        $scope.loading = false;
      });
  }

  function _editLayoutSection(layoutSection, $event) {
    if ($event) $event.preventDefault();

    layoutSection.editing = true;

    $scope.layoutSectionForm = _.extend({}, layoutSection);
  }

  function _deleteLayoutSection(layoutSection, $event) {
    if ($event) $event.preventDefault();

    modalService.confirmation({
        modalHeader: `Delete Section ${layoutSection.name}`,
        modalMessage: 'Are you sure you want to delete this section?',
        confirmBtnTxt: 'Delete Section',
        confirmingBtnTxt: 'Deleting...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          layoutSectionService.deleteById(layoutSection.id)
            .then(() => {
              const foundLayout = _.findWhere($scope.layoutSections, {
                id: layoutSection.id
              });

              $scope.layoutSections = _.without($scope.layoutSections, foundLayout);

              result.modalInstance.close();

              alertService.success('Section Removed');
            })
            .catch(error => {
              alertService.error(sdkUtils.getErrorFromResponse(error));
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function _saveLayoutSection(layoutSection, $event) {
    if ($event) $event.preventDefault();

    layoutSectionService.updateById(layoutSection.id, {
        name: $scope.layoutSectionForm.name
      })
      .then(result => {
        for (let section of $scope.layoutSections) { //eslint-disable-line
          if (section.id === result.id) {
            _.extend(section, result);
          }
        }
      })
      .then(() => {
        layoutSection.editing = false;
      });
  }

  function _addLayoutTable($event) {
    if ($event) $event.preventDefault();

    $scope.addingTable = true;

    layoutTableService.create({
        venueId: $stateParams.venueId,
        layoutId: $scope.currentLayout.id,
        yPos: 1,
        xPos: 1,
        name: '0',
        size: 'LARGE',
        type: 'ROUND'
      })
      .then(newTable => {
        $scope.layoutTables.unshift(newTable);

        $scope.editLayoutTable(newTable);

        _mapLayoutTables();

        alertService.success('Table added.');
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      })
      .finally(() => {
        $scope.addingTable = false;
      });
  }

  function _editLayoutTable(layoutTable, $event) {
    if (!layoutTable) return;
    if ($event) $event.preventDefault();

    _.each($scope.layoutTables, lt => {
      lt.editing = false;
    });

    layoutTable.editing = !layoutTable.editing;

    $scope.layoutTableForm.name = layoutTable.name;
    $scope.layoutTableForm.type = layoutTable.type;
    $scope.layoutTableForm.venueLayoutSection = layoutTable.venueLayoutSection;
  }

  function _handleTableMoved() {
    const tableId = jQuery(this).attr('data-id');

    const layoutTable = _.findWhere($scope.layoutTables, {
      id: tableId
    });

    layoutTable.saving = true;

    const position = jQuery(this).position();
    const xPos = (position.left / jQuery('.tables-container').width()) * 100;
    const yPos = (position.top / jQuery('.tables-container').height()) * 100;

    //Save new Positon
    const saveObject = {
      id: layoutTable.id,
      yPos: yPos,
      xPos: xPos
    };

    layoutTableService.updateById(layoutTable.id, saveObject)
      .then(updatedTable => {
        const foundTable = _.findWhere($scope.layoutTables, {
          _id: updatedTable.id
        });

        if (foundTable) _.extend(foundTable, updatedTable);
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      })
      .finally(() => {
        layoutTable.saving = false;
      });
  }

  function _saveLayoutTable(layoutTable, $event) {
    if (!layoutTable) return;
    if ($event) $event.preventDefault();

    $scope.savingLayoutTable = true;

    const saveObject = {
      id: layoutTable.id,
      yPos: layoutTable.yPos || 10,
      xPos: layoutTable.xPos || 10,
      name: $scope.layoutTableForm.name,
      type: $scope.layoutTableForm.type,
      venueLayoutSection: $scope.layoutTableForm.venueLayoutSection || null
    };

    layoutTableService.updateById(layoutTable.id, saveObject)
      .then(updatedTable => {
        alertService.success('Table updated.');

        const foundTable = _.findWhere($scope.layoutTables, {
          _id: updatedTable.id
        });

        if (foundTable) _.extend(foundTable, updatedTable);

        layoutTable.editing = false;
        layoutTable.selected = false;
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      })
      .finally(() => {
        $scope.savingLayoutTable = false;
      });
  }

  function _addFloorplan(layout, $event) {
    if ($event) $event.preventDefault();

    modalService.addVenueLayout({
        venueLayout: layout,
        venueId: $stateParams.venueId,
        modalHeader: layout ? `Update Floorplan ${layout.name}` : null
      })
      .then(result => {
        if (result && result.venueLayout) {
          if (layout) {
            angular.extend(layout, result.venueLayout);
          } else {
            $scope.layouts.push(result.venueLayout);

            if ($scope.layouts.length === 1) {
              $timeout(() => {
                $scope.changeLayout(result.venueLayout);
              });
            }
          }

          alertService.success('Floorplan saved.');
        }
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  function _currentSections() {
    return $scope.layoutSections ? $scope.layoutSections.filter(section => section.venueLayout === $scope.currentLayout.id) : null;
  }

  function _sectionSelected(section) {
    section.selected = true;

    // select all tables in section
    $scope.layoutTables.forEach(table => {
      if (table.venueLayoutSection === section.id) table.selected = true;
    });
  }

  function _sectionDeselected(section) {
    section.selected = false;

    // de-select all tables in section
    $scope.layoutTables.forEach(table => {
      if (table.venueLayoutSection === section.id) table.selected = false;
    });
  }

  function _deleteFloorplan(layout, $event) {
    if (!layout) return;
    if ($event) $event.preventDefault();

    modalService.confirmation({
        modalHeader: `Delete Floorplan ${layout.name}`,
        modalMessage: 'Are you sure you want to delete this floorplan?',
        confirmBtnTxt: 'Delete Floorplan',
        confirmingBtnTxt: 'Deleting...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          layoutService.deleteById(layout.id)
            .then(() => {
              const foundLayout = _.findWhere($scope.layouts, {
                id: layout.id
              });

              $scope.layouts = _.without($scope.layouts, foundLayout);

              result.modalInstance.close();

              alertService.success('Floorplan Removed');
            })
            .catch(error => {
              alertService.error(sdkUtils.getErrorFromResponse(error));
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function _mapLayoutTables() {
    const numberRegex = new RegExp(/^[0-9]*$/ig);

    _.each($scope.layoutTables, layoutTable => {
      if (layoutTable.name && _.isString(layoutTable.name) && layoutTable.name.match(numberRegex)) {
        layoutTable.name = parseInt(layoutTable.name, 10);
      }
    });
  }
}

SettingsVenueFloorplansCtrl.$inject = [
  '$scope',
  '$q',
  '$stateParams',
  'jsSdk.layout',
  'jsSdk.layoutTable',
  'jsSdk.layoutSection',
  'jsSdk.utils',
  'alertService',
  '$state',
  'ERROR_MESSAGES',
  'modalService',
  '$timeout',
  'jsSdk.venue'
];

export default SettingsVenueFloorplansCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsVenueFloorplans/settingsVenueFloorplansCtrl.js